import classNames from 'classnames';
import React from 'react';
import styles from './styles.sass';

type ButtonProps = {
  kind?: 'button';
  children: React.ReactNode;
  onClick: () => void;
  isDisabled?: boolean;
  color?: 'white' | 'purple' | 'red';
  className?: string;
  type?: 'button' | 'submit' | 'reset';
};

type LinkProps = {
  kind: 'link';
  children: React.ReactNode;
  href: string;
  isDisabled?: boolean;
  color?: 'white' | 'purple';
  className?: string;
};

type Props = ButtonProps | LinkProps;

export const Button = (props: Props): JSX.Element => {
  const { isDisabled, className, color, children } = props;
  const cx = classNames(
    styles.button,
    color !== undefined ? styles[color] : null,
    className !== undefined ? { [className]: className } : null,
    { [styles.disabled]: isDisabled }
  );
  switch (props.kind) {
    case 'link': {
      const { href } = props;
      return (
        <a href={href} className={cx}>
          {children}
        </a>
      );
    }
    default:
    case 'button': {
      const { type, onClick } = props;
      return (
        <button type={type} className={cx} onClick={onClick}>
          {children}
        </button>
      );
    }
  }
};

Button.defaultProps = {
  kind: 'button',
};
